import React from "react";
import Redirect from "components/Redirect";

const Pricing: React.FC = () => {
    let redirectURL = "/#pricing";
    return <Redirect to={redirectURL} />;
};

export default Pricing;
